import Register from '@/components/authentication/Register.tsx';

export const Route = createFileRoute({
	component: Register,
	validateSearch: (search: Record<string, unknown>) => ({
		email: (search.email as string) || undefined,
		redirect: (search.redirect as string) || undefined,
	}),
});
